export default "__VITE_ASSET__BMxiUppx__"